import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import { StorageService } from "../../services/storage.service";
import { CommonService } from "src/app/services/common.service";
@Component({
  selector: "app-professor-upcoming-schedule",
  templateUrl: "./professor-upcoming-schedule.component.html",
  styleUrls: ["./professor-upcoming-schedule.component.css"],
})
export class ProfessorUpcomingScheduleComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  vendorsched: any;
  venlength: any;
  vendorschedule: any;
  page: number = 1;
  page_size: number = 10;
  department_id: any;
  subject_id: any;
  classroom_id: any;
  video_message: any;
  batch_id: any;
  pageshow: boolean;
  filter_from: string;
  filter_end: string;
  filter_date: string;
  filter: any;
  video: Object;
  cam: any;
  department: Object;
  dept: any;
  classroom: Object;
  class: any;
  batch: Object;
  batchData: any;
  subject: Object;
  subjectData: any;
  pagedItems: any[];
  p: number;
  total: any;
  total_count: any;
  page_count: any[];
  htmlpageshow: boolean;
  searchForm: any;
  isLoginType: boolean;
  roleId: any;
  professorid: any;
  filtervalues: boolean;
  chiparray: any = [];
  professorname: any = [];
  professorData: any = [];
  assignSubmitted: boolean = false;
  assignForm: FormGroup;
  videoListId: any;
  assignProfessor: any;
  professor_id: any;
  constructor(
    private storageService: StorageService,
    public globalService: GlobalService,
    private modalService: NgbModal,
    private datepipe: DatePipe,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public commonService: CommonService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.route.queryParams.subscribe((params) => {
      this.isLoginType = !!params["loginType"];
      this.globalService.loginType = params.loginType;
      if (params.loginType == "impersonate") {
        this.roleId = this.ls.get("impersonate_role");
      } else {
        this.roleId = this.storageService.getRole();
      }
    });
    this.assignForm = this.fb.group({
      sub_name: ["", [Validators.required]],
      profname: ["", [Validators.required]],
    });
    this.searchForm = this.fb.group({
      vidstatus: [""],
      depname: [""],
      subjectname: [""],
      batchname: [""],
      classname: [""],
    });
    await this.getvendorschedule();
    this.getVideosStatus();
    this.getDepartment();
    this.getSubject();
    this.getclassroom();
    this.getBatch();
    this.getProfessor();
    await this.getPage(this.page);
  }
  get forms1() {
    return this.searchForm.controls;
  }
  get form2() {
    return this.assignForm.controls;
  }
  async getVideosStatus() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.video = await this.globalService.get(
      "classVideoDetail/list/dropdown/schedule-status",
      filter
    );
    this.cam = this.video["content"];
    this.spinner.hide();
  }
  async getDepartment() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter, true
    );

    this.dept = this.department["content"];
    this.spinner.hide();
  }
  async getPage(page: number) {
    this.page = page;
    await this.getvendorschedule();
    const res = await this.serverCall(this.vendorsched, page);
    this.total = this.total_count;
    this.p = page;

    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  async getclassroom() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.classroom = await this.globalService.get(
      "classroom/list/dropdown",
      filter, true
    );

    this.class = this.classroom["content"];
    this.spinner.hide();
  }
  async getBatch() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.batch = await this.globalService.get("batch/list/dropdown", filter, true);

    this.batchData = this.batch["content"];
    this.spinner.hide();
  }
  async getSubject() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.subject = await this.globalService.get(
      "subject/list/dropdown",
      filter, true
    );

    this.subjectData = this.subject["content"];
    this.spinner.hide();
  }

  async onDepartmentChange() {
    await this.getSubjectDropdown();

  }

  async getSubjectDropdown() {
    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    const departmentId = this.searchForm.get("depname")?.value;
    if (departmentId) {
      filter.department_id = departmentId;
    }

    const subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = subject["content"] || [];

    // Clear previously selected subject if needed
    this.searchForm.patchValue({
      subjectname: null,
    });
  }

  async getvendorschedule() {
    this.spinner.show();
    this.route.queryParams.subscribe((params) => {
      this.isLoginType = !!params["loginType"];
      this.globalService.loginType = params.loginType;
      if (params.loginType == "impersonate") {
        this.roleId = this.ls.get("impersonate_role");
        this.professorid = this.ls.get("impersonate_user_id");
      } else {
        this.professorid = this.ls.get("createdBy");
      }
    });
    var startUTCDate = moment(this.filter_from, "YYYY-MM-DD").utc();
    var endUTCDate = moment(this.filter_end, "YYYY-MM-DD").utc();

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      page: this.page,
      page_size: this.page_size,
      professor_id: this.professorid,
      video_status_id: this.video_message,
      department_id: this.department_id,
      batch_id: this.batch_id,
      subject_id: this.subject_id,
      classroom_id: this.classroom_id,
      camera_start: isNaN(startUTCDate.toDate().getTime())
        ? null
        : startUTCDate.format("YYYY-MM-DD"),
      camera_end: isNaN(endUTCDate.toDate().getTime())
        ? null
        : endUTCDate.format("YYYY-MM-DD"),
    };

    this.vendorschedule = await this.globalService.get(
      "timetable/dashboard-upcoming-professor-schedule",
      filter
    );
    this.vendorsched = this.vendorschedule["content"];
    this.total_count = this.vendorschedule["content"].count;
    if (this.pageshow === true) {
      this.page_count = [];
      let page_count = Math.ceil(this.total_count / this.page_size);
      if (page_count > 1) {
        this.htmlpageshow = true;
      } else {
        this.htmlpageshow = false;
      }
    }
    this.venlength = this.vendorsched.length;

    this.spinner.hide();
  }
  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(dateValue, timeValue, isDateRequested);
  }
  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
  }
  getFilterDate(filter_date) {
    if (filter_date) {
      this.filter = filter_date;
      let from = moment(this.filter[0]).format("YYYY-MM-DD 00:00:00");
      let end = moment(this.filter[1]).format("YYYY-MM-DD 23:59:59");

      this.filter_from = this.datepipe.transform(
        from,
        "yyyy-MM-dd HH:mm:ss",
        "+0530"
      );
      this.filter_end = this.datepipe.transform(
        end,
        "yyyy-MM-dd HH:mm:ss",
        "+0530"
      );
    }
  }
  Filter(department_id, subject_id, classroom_id, batch_id) {
    this.filtervalues = true;
    this.chiparray = [];

    if (this.department_id != undefined && this.department_id != "") {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
    }

    if (this.subject_id != undefined && this.subject_id != "") {
      var subject = this.subjectData.filter((x) => x.id == this.subject_id);
      this.chiparray.push("Subject:" + " " + subject[0].name);
    }

    if (this.batch_id != undefined && this.batch_id != "") {
      var batch = this.batchData.filter((x) => x.id == this.batch_id);
      this.chiparray.push("Batch:" + " " + batch[0].batch);
    }

    if (this.classroom_id != undefined && this.classroom_id != "") {
      var classroom = this.class.filter((x) => x.id == this.classroom_id);
      this.chiparray.push("Class:" + " " + classroom[0].name);
    }
    this.department_id = department_id;
    this.subject_id = subject_id;
    this.classroom_id = classroom_id;
    this.batch_id = batch_id;
    this.pageshow = true;
    this.page = 1;
    this.getvendorschedule();
  }

  res() {
    this.filtervalues = false;
    this.department_id = null;
    this.subject_id = null;
    this.professor_id = null;
    this.classroom_id = null;
    this.filter_from = null;
    this.filter_end = null;
    this.video_message = null;
    this.filter_date = null;
    this.batch_id = null;
    this.searchForm.reset();
    this.assignSubmitted = false;
    this.page = 1;
    this.pageshow = true;
    this.getvendorschedule();
  }
  paginationCount(value) {
    this.page = 1;
    this.page_size = value;
    this.getvendorschedule();
  }
  onAssign(content, id) {
    if (this.ls.get("token")) {
      this.videoListId = id;
      this.modalService.open(content, { scrollable: true });
    }
    this.assignSubmitted = false;
    this.res();
    this.getProfessor();
  }
  async getProfessor() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.professorname = await this.globalService.get(
      "user/profeser/dropdown",
      filter, true
    );

    this.professorData = this.professorname["content"];
    this.spinner.hide();
  }

  async onAssignSubmit() {
    this.assignSubmitted = true;
    if (this.assignForm.invalid) {
      return;
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      id: this.videoListId,
      professor_id: this.assignForm.controls.profname.value,
      subject_id: this.assignForm.controls.sub_name.value,
    };
    this.spinner.show();
    this.assignProfessor = await this.globalService.update(
      "classVideoDetail/assign/professor",
      filter
    );
    if (this.assignProfessor["status"] === 200) {
      this.res();
      this.getProfessor();
      this.assignSubmitted = false;
      this.modalService.dismissAll();
      this.spinner.hide();
      Swal.fire("Success!", this.assignProfessor["message"], "success");
    } else if (this.assignProfessor["status"] === 400) {
      Swal.fire("Error", this.assignProfessor["error"].message, "error");
      this.spinner.hide();
    } else {
      Swal.fire("Warning!", "Please fill out the required fields.");
      this.spinner.hide();
    }
  }
}
